import {
  getV1RutterConnectionsConnectionIdTaxRates,
  GetV1RutterConnectionsConnectionIdTaxRatesData,
  Rutter_TaxRate_Read,
} from '@treadinc/horizon-api-spec';
import { FieldValues } from 'react-hook-form';

import {
  RutterMappedRecord,
  RutterTaxRate,
  RutterTaxRateMappedRecord,
} from '~hooks/useRutter/models';

import AsyncAutocompleteField from '../v2/Autocomplete/AsyncAutocompleteField';
import { CommonAsyncAutocompleteFieldProps } from '../v2/Autocomplete/types';

type Props<T extends FieldValues> = CommonAsyncAutocompleteFieldProps<
  T,
  Rutter_TaxRate_Read,
  RutterMappedRecord,
  GetV1RutterConnectionsConnectionIdTaxRatesData
> & { companyId: string; connectionId: string };

// Offers only the QuickBooks tax rates not yet mapped to a Tread tax rate schedule.
export default function AutocompleteRutterTaxRatesTypeahead<T extends FieldValues>({
  companyId,
  connectionId,
  ...rest
}: Props<T>) {
  return (
    <AsyncAutocompleteField
      {...rest}
      queryName="AutocompleteRutterTaxRatesTypeahead"
      fetchFn={{
        arguments: {
          path: { 'company-id': companyId, 'connection-id': connectionId },
          query: { 'filter[unmapped]': true },
        },
        request: getV1RutterConnectionsConnectionIdTaxRates,
      }}
      filterOptions={(options) => options.filter(({ _entity }) => _entity.isActive)}
      parseFn={(item: Rutter_TaxRate_Read) => {
        const taxRate = RutterTaxRate.parse(item);
        const mappedRecord = new RutterTaxRateMappedRecord(
          taxRate.id,
          taxRate.name ?? taxRate.code,
          taxRate.totalTaxRate,
          taxRate.isActive,
        );

        return { _entity: mappedRecord, label: mappedRecord.label, value: taxRate.id };
      }}
    />
  );
}
